import { ImageName } from "@mcleod/images";
import { DemoDefinition } from "../DemoDefinition";

export class ComponentDemoDefinition extends DemoDefinition {
    private _componentName: string;
    private relativeComponentPath: string;

    constructor(componentName: string, relativeComponentPath: string, imageName: ImageName) {
        super(null, [ "Components", componentName ], imageName);
        this.componentName = componentName;
        this.relativeComponentPath = relativeComponentPath;
    }

    get examplesClass(): string {
        return `component-demo/components/examples/Demo${this.componentName}Examples`;
    }

    get componentName(): string {
        return this._componentName;
    }

    private set componentName(value: string) {
        this._componentName = value;
    }

    get componentPath(): string {
        return `components/components/${this.relativeComponentPath}`;
    }

    override get runtimePath(): string {
        return `components/ComponentDemo?demoDefinition=${this.type}`;
    }
}
